<template>
  <div>
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      fwd: null,
      p:null,
      q:null
    };
  },
  created()
  {
    this.p=this.$route.query.p;
    this.q=this.$route.query.q;
    this.fwd=this.$route.query.fwd;
    console.log(15,this.$route);
    console.log(16,this.$route.query);
    console.log(17,this.p);
    var token=null;
    var halt=null;
    if (this.$route.query.t)
    {
      //token=this.$route.query.t.split('?')[0]
      token=this.$route.query.t
    }
    if(this.$route.query.halt)
    {
      halt=this.$route.query.halt.split('?')[0]
    }
    console.log(30,token);
    var url;
    //var url2;
    //console.log(20,this.p.split('?')[0])

    /*if (this.p.includes('maps.app.goo.gl')||this.p.includes('google.com/maps/dir'))
    {
      var url=this.p;
      console.log(40,url);
    }
    else
    {
      */
      var dir=this.p?this.p.split('?')[0]:null;
      var fwd=this.fwd?this.fwd.split('?')[0]:null;
    //}

    /*
    if (this.p.includes('destination='))
    {
      url2='https://www.google.com/maps/dir/?api=1&'+this.p;
      console.log(38,url2);
      var url='https://www.google.com/maps/dir/?api=1&'+this.p.split('?')[0];
      console.log(40,url);
    }
    else
    {
      var url=this.p.split('?')[0];
    }
    */
    
    if(token)
    {
      this.click(token)
    }
    console.log(50,dir,fwd);
    //https://ibookrestaurant.com/?subdomain=farina44&page=forward?p=https://www.google.com/maps/dir/?api=1&destination=Via Rivarola, 44, 16043 Chiavari GE, Italia
    if(halt!='1')
    {
      if (fwd)
      {
        console.log(70,fwd,atob(fwd));
        window.location.href = atob(fwd);
      }
      else if (dir)
      {
        window.location.href = 'https://www.google.com/maps/dir//'+atob(dir.replace('/',''));// this.p
      }
      else
      {

      }
    }
},  
  mounted: function () {
  },
  methods:
  {    
    async click(token)
    {
        const browser=window.navigator.userAgent;
        const payload={"action":"token","token":token,"browser":browser}
        console.log(65,payload)
        const res = await this.$http.post('/mktg/mktg.php', payload);
        console.log(67,res)
        //window.location.href = url;// this.p
    } 
  },
};
</script>